import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import Breadcrumb from '../../components/breadcrumbs/Breadcrumb';

import SitesCataloguesTable from '../../components/sitesCatalogues/SitesCataloguesTable';

function SitesCatalogues() {

  return (
    <div className="uk-container">

      <div data-uk-grid>

        <div className="uk-width-3-4">
          <Breadcrumbs>
            <Breadcrumb><NavLink to="/">Панель администратора</NavLink></Breadcrumb>
            <Breadcrumb><span>Сайты-каталоги</span></Breadcrumb>
          </Breadcrumbs>
        </div>

      </div>

      <h1 className="uk-heading-line uk-text-center">
        <span>Сайты-каталоги</span>
      </h1>

      <h1 className="uk-heading-divider"></h1>

      <SitesCataloguesTable />

    </div>
  )
}

export default SitesCatalogues;
